import {
  Button,
  IconArrowInbox,
  IconArrowOutOfBox,
  IconBarChart,
  SequenceMenu,
  Flex
} from '@sequencehq/core-components'
import { useSelectedCurrency } from '../utils/useSelectedCurrency'
import { ExportCSVModal } from '../common/ExportCSVModal'
import {
  PushToXeroModal,
  useXeroIntegrationStatus
} from '../common/PushToXeroModal'
import { useSelectedDateRange } from '../utils/useSelectedDateRange'
import { useSearchParams } from 'react-router-dom'
import { RevRecHeader } from '../common/RevRecHeader'
import { GenerateAnalysisReportModal } from './generateAnalysisReport/GenerateAnalysisReportModal'
import { useAnalysisReportEligibility } from './generateAnalysisReport/useAnalysisReportEligibility'
import { GENERATE_ANALYSIS_REPORT_COPY } from './generateAnalysisReport/generateAnalysisReport.constants'

export const RevenueRecognitionDashboardHeader = () => {
  const { currency } = useSelectedCurrency()
  const { dateRange } = useSelectedDateRange()
  const { hasConnection: hasXeroConnection } = useXeroIntegrationStatus()
  const canGenerateAnalysisReport = useAnalysisReportEligibility()

  const [searchParams] = useSearchParams()
  const customerIds = searchParams.get('customerId')
  const productIds = searchParams.get('productId')
  const invoiceIds = searchParams.get('invoiceId')
  const creditNoteIds = searchParams.get('creditNoteId')

  // Secondary actions live behind a kebab; each menu item owns its modal via the
  // trigger, mirroring the Settings → Team row-actions pattern.
  const menuItems = [
    canGenerateAnalysisReport && (
      <GenerateAnalysisReportModal
        key="analysis"
        trigger={
          <SequenceMenu.Item
            uuid="revrec.actions.generateAnalysis"
            label={GENERATE_ANALYSIS_REPORT_COPY.triggerLabel}
            iconLeft={<IconBarChart />}
            data-testid={GENERATE_ANALYSIS_REPORT_COPY.testIds.trigger}
          />
        }
      />
    ),
    hasXeroConnection && !!currency && (
      <PushToXeroModal
        key="push"
        currency={currency}
        trigger={
          <SequenceMenu.Item
            uuid="revrec.actions.pushToXero"
            label="Push to Xero"
            iconLeft={<IconArrowOutOfBox />}
            data-testid="revrec.detail.pushToXero"
          />
        }
      />
    )
  ].filter(Boolean)

  return (
    <RevRecHeader>
      <RevRecHeader.Breadcrumbs route="journal-reports" />
      <Flex alignItems="center" gap="8px">
        {!!currency && (
          <ExportCSVModal
            from={dateRange[0]}
            to={dateRange[1]}
            currency={currency}
            customerIds={customerIds ? customerIds.split(',') : undefined}
            productIds={productIds ? productIds.split(',') : undefined}
            invoiceIds={invoiceIds ? invoiceIds.split(',') : undefined}
            creditNoteIds={creditNoteIds ? creditNoteIds.split(',') : undefined}
            trigger={
              <Button
                variant="secondary"
                leadingIcon={<IconArrowInbox />}
                data-testid="revrec.detail.exportCSV"
              >
                Export to CSV
              </Button>
            }
          />
        )}
        {menuItems.length > 0 && (
          <SequenceMenu
            variant="ghost"
            buttonSize="medium"
            alignment="bottom-right"
            data-testid="revrec.detail.actionsMenu"
            items={menuItems}
          />
        )}
      </Flex>
    </RevRecHeader>
  )
}
